export const DESKTOP = 992
export const IPAD = 768
